<script>
	import { onMount, createEventDispatcher } from 'svelte'
	import { styles } from '../scripts/styles'
	import { storeElementID } from '../scripts/Store.svelte'

	export let width
	export let height
	export let range
	export let ID
	export let initialValue = 100
	export let sizeUnit = 'px'
	export let unit = '%'
	export let sliderColor = 'transparent'
	export let fillerColor = 'white'
	export let indicatorColor = 'blue'
	export let caretColor = 'green'
	export let caretBorder = 'orange'

	//create css units
	let sliderWidth = width + sizeUnit
	let sliderHeight = height + sizeUnit

	//the value to use for sliders on page
	let initialPosition

	//check if the component is mounted
	let isMounted = false

	//cast for calculations
	range = parseInt(range)

	let elementID
	storeElementID.subscribe((value) => {
		elementID = value
	})

	$: if (elementID) {
		if (unit === '%' && range === 1) {
			initialPosition = parseFloat(initialValue).toFixed(2)
		}
		if (unit === '%' && range > 2) {
			initialPosition = parseInt(initialValue)
		}

		if (isMounted) {
			const width = document.getElementById('s_' + ID).parentElement.clientWidth
			const containerOffset = document.getElementById('s_' + ID).offsetLeft

			//cast the % to px
			if (unit === '%' && range > 1) {
				initialPosition = Math.round((initialValue * width) / range)
			}
			if (unit === '%' && range === 1) {
				initialPosition = width * initialValue
			}
			if (unit === 'px') initialPosition = Math.round((initialValue * width) / range)

			//set the number if it's not a slider used in ColorSelector
			if (
				ID === 3 ||
				ID === 4 ||
				ID === 5 ||
				ID === 6 ||
				ID === 7 ||
				ID === 8 ||
				ID === 9 ||
				ID === 10 ||
				ID === 11 ||
				ID === 12 ||
				ID === 13 ||
				ID === 14 ||
				ID === 15 ||
				ID === 16 ||
				ID === 17 ||
				ID === 18 ||
				ID === 19 ||
				ID === 20 ||
				ID === 21 ||
				ID === 22 ||
				ID === 23 ||
				ID === 24 ||
				ID === 25 ||
				ID === 26 ||
				ID === 27 ||
				ID === 28 ||
				ID === 29 ||
				ID === 30 ||
				ID === 31 ||
				ID === 32 ||
				ID === 33 ||
				ID === 34 ||
				ID === 35 ||
				ID === 36 ||
				ID === 37 ||
				ID === 38 ||
				ID === 40 ||
				ID === 41 ||
				ID === 42 ||
				ID === 43 ||
				ID === 44 ||
				ID === 45 ||
				ID === 46 ||
				ID === 47 ||
				ID === 48 ||
				ID === 49 ||
				ID === 50 ||
				ID === 51 ||
				ID === 52 ||
				ID === 53 ||
				ID === 54 ||
				ID === 55 ||
				ID === 56 ||
				ID === 57 ||
				ID === 58 ||
				ID === 59 ||
				ID === 60 ||
				ID === 61 ||
				ID === 62 ||
				ID === 63
			) {
				const hasSlider = document.getElementById('slider_' + ID)
				if (hasSlider)
					document.getElementById('slider_' + ID).innerText = Math.round((range * initialPosition) / width) + unit
			}

			//set the initial position of the caret
			document.getElementById('i_' + ID).style.width = initialPosition + 'px'
			document.getElementById('f_' + ID).style.width = width - initialPosition + 'px'
		}
	}

	//for the moving action
	let containerOffset
	let entryPoint
	let distance
	let ismove = false

	//dispatcher to return reesult to caller
	let dispatch = createEventDispatcher()

	//functions

	//get the distance of mouse-move relative to container with
	const get_distance = (e) => {
		const rect = e.target.offsetParent.getBoundingClientRect()
		if (e.type === 'mousemove') distance = e.layerX
		if (e.type === 'touchmove') distance = Math.round(e.targetTouches[0].clientX - rect.left)
		if (ismove) slider_move(distance)
	}

	//make the move
	const slider_move = (d) => {
		const sliderWidth = document.getElementById('s_' + ID).clientWidth
		const left = document.getElementById('i_' + ID)
		const right = document.getElementById('f_' + ID)

		//translate width to pixels (if sizeUnit is %)
		left.style.width = left.clientWidth + 'px'
		right.style.width = right.clientWidth + 'px'

		left.style.width = d + 'px'
		right.style.width = sliderWidth - d + 'px'

		if (d + 5 > sliderWidth) {
			right.style.opacity = '0'
		} else {
			right.style.opacity = '1'
		}

		let v = calc_value(d)
		return_result(v)
	}

	const calc_value = (v) => {
		let cWidth = document.getElementById('s_' + ID).clientWidth

		let value = v

		if (range === 1) {
			value = (range / cWidth) * v
			if (value > 0.98) value = 1
			if (value < 0.1) value = 0
		} else {
			if (value === 1) value = 0
			else if (range === 100 && value > 98) value = 100
			else value = Math.ceil((range * v) / cWidth)
		}

		return value
	}

	//start move
	const start_move = () => {
		ismove = true
	}

	//unset ismove
	const release_move = () => {
		ismove = false
	}

	//return the result
	const return_result = (v) => {
		dispatch('sliderMove', { value: v })
	}

	//get the left value of container
	onMount(() => {
		isMounted = true
	})
</script>

<svelte:window on:touchend={release_move} on:mouseup={release_move} />

<div
	class="slider"
	id="s_{ID}"
	use:styles={{ sliderWidth, sliderHeight, sliderColor }}
	on:touchstart={start_move}
	on:touchmove={get_distance}
	on:mousedown={start_move}
	on:mousemove={get_distance}
>
	<div class="indicator" id="i_{ID}" use:styles={{ sliderHeight, indicatorColor }} />
	<div class="caret" use:styles={{ sliderHeight, caretColor, caretBorder }} />
	<div class="filler" id="f_{ID}" use:styles={{ sliderHeight, fillerColor }} />
</div>

<style>
	.slider {
		position: relative;
		display: flex;
		align-items: center;
		width: var(--sliderWidth);
		height: var(--sliderHeight);
		background-color: var(--sliderColor);
	}

	.indicator {
		width: 100%;
		height: calc(var(--sliderHeight) / 100 * 30);
		background-color: var(--indicatorColor);
	}

	.filler {
		width: 0;
		height: calc(var(--sliderHeight) / 100 * 30);
		background-color: var(--fillerColor);
	}

	.caret {
		width: calc(var(--sliderHeight) / 100 * 80);
		height: calc(var(--sliderHeight) / 100 * 80);
		border: 2px solid var(--caretBorder);
		background-color: var(--caretColor);
		cursor: move;
	}
</style>
